/* RAVIN / THE FIT LAB — Chapter 02: choose your fit.
   Presentation-only enhancement. The core module owns measurements, preference
   state, API calculations, size availability and the final product selection. */
(()=>{
  if(window.__RavinFitLabFitPreference2026)return;
  window.__RavinFitLabFitPreference2026=true;
  const esc=v=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const copy={
    en:{
      prompt:'How do you want this piece to feel on you?',
      desc:{
        'Slim':['CLOSE TO BODY','Less extra room. A sharper silhouette.'],
        'True to Size':['AS DESIGNED','The garment’s intended silhouette.'],
        'Relaxed':['MORE ROOM','A looser, easy-going feel.']
      },
      note:'Your choice guides the size recommendation. The garment’s original cut still matters.',
      visual:'FIT PREVIEW · ILLUSTRATIVE',
      pick:'YOUR FIT',
      action:'REVEAL MY FIT  →',
      busy:'FINDING YOUR FIT…'
    },
    ar:{
      prompt:'تحب القطعة تبقى عاملة إزاي عليك؟',
      desc:{
        'Slim':['قريب من الجسم','مساحة أقل وقصة أقرب للجسم.'],
        'True to Size':['زي تصميمها','القصة الأصلية للقطعة.'],
        'Relaxed':['مساحة أكبر','قصة أوسع وحركة أريح.']
      },
      note:'اختيارك بيساعدنا نرشّح المقاس، لكن قصة القطعة الأصلية بتفضل زي ما هي.',
      visual:'معاينة توضيحية للقصة',
      pick:'اختيارك',
      action:'اعرف مقاسك  ←',
      busy:'بنحسب مقاسك…'
    }
  };
  const isFit2=ov=>ov?.dataset.rvFlView==='fit'&&ov?.dataset.rvFlChapter==='2'&&ov?.dataset.open==='true';
  const look=choice=>choice==='Slim'?'Slim':choice==='Relaxed'?'Relaxed':'True to Size';
  function miniature(choice){
    const outlines={
      'Slim':'M36 37 L42 33 Q50 37 58 33 L64 37 L75 49 L68 59 L62 55 L61 93 L39 93 L38 55 L32 59 L25 49 Z',
      'True to Size':'M33 37 L42 33 Q50 37 58 33 L67 37 L81 49 L72 62 L65 57 L66 96 L34 96 L35 57 L28 62 L19 49 Z',
      'Relaxed':'M28 37 L42 33 Q50 37 58 33 L72 37 L88 49 L77 66 L69 60 L73 100 L27 100 L31 60 L23 66 L12 49 Z'
    };
    return '<svg class="rv-fl-fit2-mini" viewBox="0 0 100 110" aria-hidden="true" focusable="false">'+
      '<path d="M39 7 L61 7 L64 30 L36 30 Z" fill="#C89A69" stroke="#8B6745" stroke-width="1.4"/>'+
      '<path d="M39 7 L45 4 L62 6 L61 12 L39 12 Z" fill="#D7B58E"/>'+
      '<path d="M42 19 Q45 16 48 19 M52 19 Q55 16 58 19" fill="none" stroke="#111411" stroke-width="1.8" stroke-linecap="round"/>'+
      '<path d="M46 24 Q50 28 54 24" fill="none" stroke="#111411" stroke-width="1.8" stroke-linecap="round"/>'+
      '<path d="'+outlines[choice]+'" fill="#111411" stroke="#343C33" stroke-width="1.5" stroke-linejoin="round"/>'+
      '<path d="M43 36 Q50 43 57 36" fill="none" stroke="#F2F0E9" stroke-width="2"/>'+
      '<path d="M36 85 L64 85" stroke="#D9F64E" stroke-width="2.4" stroke-dasharray="5 3"/>'+
      '</svg>';
  }
  // Single garment silhouette, smoothly morphed between preferences.
  // This is a visual illustration only; the core Fit Lab still sends the
  // exact original preference value to Marketing Studio for size evaluation.
  const SHAPES={
    'Slim':'M414 548 L472 518 Q551 548 631 518 L699 546 L766 613 L709 697 L669 673 L667 928 Q552 940 435 928 L436 672 L395 695 L342 613 Z',
    'True to Size':'M400 543 L475 511 Q552 544 634 511 L710 543 L796 616 L727 714 L683 686 L697 963 Q552 981 418 963 L420 685 L376 713 L309 615 Z',
    'Relaxed':'M379 543 L475 503 Q552 539 636 503 L732 542 L832 617 L744 750 L700 719 L738 1006 Q552 1028 384 1006 L405 719 L360 750 L271 617 Z'
  };
  function garment(choice){
    return '<svg class="rv-fl-fit2-garment" viewBox="0 0 1122 1402" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">'+
      '<path class="rv-fl-fit2-garment__body" data-rv-fit2-morph d="'+SHAPES[look(choice)]+'" fill="#171B18" stroke="#596258" stroke-width="9" stroke-linejoin="round"/>'+
      '<path d="M477 519 Q551 578 631 519" fill="none" stroke="#E8E8DD" stroke-width="11"/>'+
      '<path d="M477 526 Q551 579 631 526" fill="none" stroke="#D9F64E" stroke-width="3"/>'+
      '<path d="M554 591 L554 901" stroke="#7D8477" stroke-width="2" opacity=".22"/>'+
      '</svg>';
  }
  const pathTokens=value=>String(value).match(/[MLQZ]|-?\d+(?:\.\d+)?/g)||[];
  function morph(figure,choice){
    const path=figure.querySelector('.rv-fl-fit2-garment [data-rv-fit2-morph]');
    if(!path)return;
    const target=SHAPES[look(choice)];
    const current=path.getAttribute('d')||target;
    if(current===target)return;
    if(path.rvFlFit2Frame)cancelAnimationFrame(path.rvFlFit2Frame);
    const from=pathTokens(current),to=pathTokens(target);
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||
       from.length!==to.length||from.some((v,i)=>/[MLQZ]/.test(v)&&v!==to[i])){
      path.setAttribute('d',target);return;
    }
    const begin=performance.now(),duration=460;
    const animate=now=>{
      if(!path.isConnected)return;
      const t=Math.min(1,(now-begin)/duration),ease=1-Math.pow(1-t,3);
      if(t>=1){path.setAttribute('d',target);return;}
      path.setAttribute('d',from.map((v,i)=>/[MLQZ]/.test(v)?v:
        (Number(v)+(Number(to[i])-Number(v))*ease).toFixed(1)).join(' '));
      path.rvFlFit2Frame=requestAnimationFrame(animate);
    };
    path.rvFlFit2Frame=requestAnimationFrame(animate);
  }

  // Approved user-supplied photographs for both women and men, Chapter 02 only.
  // These are illustrative fit preferences, not garment-specific fit promises.
  // Keep the original Fit Lab preference state and Marketing Studio API payload.
  const FIT_PHOTOS={
    "women": {
      "Slim": "https://cdn.shopify.com/s/files/1/0013/7743/5701/files/ravin-fitlab-ch02-female-slim-2026.jpg?v=1792349614",
      "True to Size": "https://cdn.shopify.com/s/files/1/0013/7743/5701/files/ravin-fitlab-ch02-female-regular-2026.jpg?v=1792349620",
      "Relaxed": "https://cdn.shopify.com/s/files/1/0013/7743/5701/files/ravin-fitlab-ch02-female-relaxed-2026.jpg?v=1792349626"
    },
    "men": {
      "Slim": "https://cdn.shopify.com/s/files/1/0013/7743/5701/files/ravin-fitlab-ch02-male-slim-2026.jpg?v=1792350674",
      "True to Size": "https://cdn.shopify.com/s/files/1/0013/7743/5701/files/ravin-fitlab-ch02-male-regular-2026.jpg?v=1792350679",
      "Relaxed": "https://cdn.shopify.com/s/files/1/0013/7743/5701/files/ravin-fitlab-ch02-male-relaxed-2026.jpg?v=1792350684"
    }
  };
  function usePhotoChoices(figure,buttons,art){
    const gender=art?.dataset.rvBrandGender;
    const photos=FIT_PHOTOS[gender];
    if(!photos)return false; // Keep existing artwork for unisex/unknown products.
    figure.dataset.rvFit2PhotoMode='true';
    figure.dataset.rvFit2PhotoGender=gender;
    art.querySelector('.rv-fl-fit2-garment')?.remove();
    if(!figure.querySelector('.rv-fl-fit2-photo-stack')){
      const markup='<div class="rv-fl-fit2-photo-stack" role="img" aria-label="RAVIN Fit Lab T-shirt fit illustration">'+
        Object.entries(photos).map(([fit,url])=>
          '<img class="rv-fl-fit2-photo" data-fit-photo="'+esc(fit)+'" src="'+esc(url)+'" alt="" aria-hidden="true" draggable="false" decoding="async" loading="eager">').join('')+
        '</div>';
      figure.insertAdjacentHTML('beforeend',markup);
    }
    buttons.forEach(button=>{
      const img=button.querySelector('.rv-fl-preference__figure');
      const src=photos[button.dataset.pref];
      if(!img||!src||img.querySelector('.rv-fl-fit2-mini-photo'))return;
      img.innerHTML='<img class="rv-fl-fit2-mini-photo" src="'+esc(src)+'" alt="" aria-hidden="true" decoding="async" loading="eager">';
    });
    return true;
  }
  function select(ov){
    const fig=ov.querySelector('.rv-fl-guided-character--fit');
    if(!fig)return;
    const choice=look(fig.dataset.fitChoice);
    morph(fig,choice);
    const activePhoto=fig.querySelector('.rv-fl-fit2-photo-stack');
    if(activePhoto){
      const name=choice==='True to Size'?'regular':choice.toLowerCase();
      activePhoto.setAttribute('aria-label','RAVIN character wearing a '+name+' fit black T-shirt (illustrative)');
    }
    const lang=ov.dir==='rtl'?'ar':'en',c=copy[lang];
    const caption=ov.querySelector('.rv-fl-fit2-hero__caption');
    if(caption){
      const label=c.visual+' / '+c.desc[choice][0];
      if(caption.textContent!==label)caption.textContent=label;
    }
    const note=ov.querySelector('[data-rv-fl-fit2-note]');
    if(note&&note.textContent!==c.note)note.textContent=c.note;
    const picked=ov.querySelector('[data-rv-fl-fit2-picked]');
    if(picked){const label=c.pick+' / '+c.desc[choice][0];if(picked.textContent!==label)picked.textContent=label;}
    ov.querySelectorAll('.rv-fl-preference[data-pref]').forEach(btn=>{
      const on=btn.dataset.pref===choice;
      btn.setAttribute('aria-pressed',String(on));
      const tick=btn.querySelector('.rv-fl-fit2-check');
      if(tick){const symbol=on?'✓':'';if(tick.textContent!==symbol)tick.textContent=symbol;}
    });
    const dock=ov.querySelector('[data-rv-fl-mobile-continue]');
    const inline=ov.querySelector('[data-rv-fl-reveal]');
    if(dock&&inline){
      const busy=inline.disabled;
      const label=busy?c.busy:c.action;
      if(dock.textContent!==label)dock.textContent=label;
      dock.disabled=busy;
      dock.setAttribute('aria-disabled',String(busy));
      dock.setAttribute('aria-busy',String(busy));
    }
  }
  function decorate(ov){
    if(!isFit2(ov))return;
    const panel=ov.querySelector('.rv-fl-guided-panel');
    const figure=ov.querySelector('.rv-fl-guided-character--fit');
    const buttons=[...ov.querySelectorAll('.rv-fl-preference[data-pref]')];
    if(!panel||!figure||buttons.length!==3)return;
    const lang=ov.dir==='rtl'?'ar':'en',c=copy[lang];
    ov.dataset.rvFlFit2Design='true';
    if(panel.dataset.rvFlFit2Ready!=='true'){
      panel.dataset.rvFlFit2Ready='true';
      panel.classList.add('rv-fl-fit2-panel');
      const hint=panel.querySelector('.rv-fl-panel__hint');
      if(hint)hint.textContent=c.prompt;
      const preferenceGrid=panel.querySelector('.rv-fl-preferences');
      if(preferenceGrid){preferenceGrid.setAttribute('role','group');preferenceGrid.setAttribute('aria-label',lang==='ar'?'اختيارات القصة':'Fit preferences');}
      buttons.forEach((btn,index)=>{
        const choice=look(btn.dataset.pref);
        const fig=btn.querySelector('.rv-fl-preference__figure');
        if(fig)fig.innerHTML=miniature(choice);
        const title=btn.querySelector('.rv-fl-preference__text');
        if(title)title.classList.add('rv-fl-fit2-card__title');
        btn.setAttribute('aria-label',(title?.textContent?.trim()||choice)+'. '+c.desc[choice][1]);
        btn.insertAdjacentHTML('afterbegin','<span class="rv-fl-fit2-card__index">0'+(index+1)+' <span class="rv-fl-fit2-check" aria-hidden="true"></span></span>');
        btn.insertAdjacentHTML('beforeend','<span class="rv-fl-fit2-card__desc">'+esc(c.desc[choice][0])+'</span>');
        btn.addEventListener('click',()=>queueMicrotask(()=>select(ov)));
      });
      const selected=panel.querySelector('.rv-fl-guided-choice');
      if(selected)selected.insertAdjacentHTML('afterend',
        '<p class="rv-fl-fit2-picked" data-rv-fl-fit2-picked></p>'+
        '<p class="rv-fl-fit2-note" data-rv-fl-fit2-note></p>');
    }
    if(figure.dataset.rvFlFit2Ready!=='true'){
      figure.dataset.rvFlFit2Ready='true';
      figure.classList.add('rv-fl-fit2-hero');
      figure.insertAdjacentHTML('afterbegin','<span class="rv-fl-fit2-hero__eyebrow">RAVIN / FIT LAB · 02</span>');
      figure.insertAdjacentHTML('beforeend','<span class="rv-fl-fit2-hero__caption" role="status" aria-live="polite">'+esc(c.visual)+'</span>');
    }
    const art=figure.querySelector('.rv-fl-brand-character__art');
    const showingApprovedPhotos=usePhotoChoices(figure,buttons,art);
    if(art&&!showingApprovedPhotos&&!art.querySelector('.rv-fl-fit2-garment'))
      art.insertAdjacentHTML('beforeend',garment(figure.dataset.fitChoice));
    const dock=ov.querySelector('[data-rv-fl-mobile-continue]');
    if(dock&&!dock.dataset.rvFlFit2Bound){
      dock.dataset.rvFlFit2Bound='true';
      dock.addEventListener('click',event=>{
        if(!isFit2(ov))return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const inline=ov.querySelector('[data-rv-fl-reveal]');
        if(inline&&!inline.disabled)inline.click();
      },true);
    }
    select(ov);
  }
  let scheduled=false;
  function synchronize(){
    scheduled=false;
    const ov=document.querySelector('.rv-fl-overlay[data-open="true"]');
    if(isFit2(ov))decorate(ov);
  }
  function schedule(){
    if(scheduled)return;
    scheduled=true;
    queueMicrotask(synchronize);
  }
  function start(){
    if(!document.body)return;
    new MutationObserver(schedule).observe(document.body,{
      subtree:true,childList:true,attributes:true,
      attributeFilter:['data-open','data-rv-fl-view','data-rv-fl-chapter']
    });
    schedule();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();